import type { ExerciseAnswerInput } from "@calega/content";

type Handler = (runId: string, answers: ExerciseAnswerInput[]) => Promise<void>;
let handler: Handler | null = null;
export function registerReflectionHandler(next: Handler) {
  handler = next;
  return () => { if (handler === next) handler = null; };
}
export function requestReflection(runId: string, answers: ExerciseAnswerInput[]) {
  return handler?.(runId, answers);
}
